<template>
  <section :id="sectionId" :class="{ disabled: disabled }">
    <h6
      data-toggle="collapse"
      class="form-subheader mb-3 user-select-none position-sticky btn-toogle-collapse-section"
      @click="!disabled ? $emit('toggleSection') : null"
      :aria-expanded="expanded ? 'true' : 'false'"
    >
      <span v-html="title"></span>
      <slot name="header-extra"></slot>
    </h6>

    <div class=" position-relative collapse" :class="expanded ? 'show' : 'collapsed'">
      <div class="loading" v-if="loading"><b-spinner label="Loading..."></b-spinner></div>
      <slot />
    </div>
  </section>
</template>

<script>
export default {
  name: 'CollapseSection',
  props: {
    sectionId: { type: String, default: null },
    title: { type: String, required: true },
    expanded: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
    loading: { type: Boolean, default: false },
  },
};
</script>

<style scoped>
.loading { position: absolute; top: 0px; left: 0px; display: flex; align-items: center; justify-content: center; width: 100%; height: 100%; background-color: rgba(255, 255, 255, 0.7); z-index: 999; }
.btn-toogle-collapse-section { cursor: pointer; }
.disabled { opacity: 0.3; }
.disabled .btn-toogle-collapse-section { cursor: not-allowed; }
</style>
